import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  icon: PropTypes.node,
};

const CardDesignerCardElementPlaceholder = ({ icon, ...props }) => {
  return (
    <div className="card-designer-card-element-placeholder" {...props}>
      {icon && (
        <span className="card-designer-card-element-placeholder-icon">
          {icon}
        </span>
      )}
    </div>
  );
};

CardDesignerCardElementPlaceholder.propTypes = propTypes;

export default CardDesignerCardElementPlaceholder;
